// External links for the 3D floor plan early-access program.

/** TestFlight build of the dedicated 3D scans iOS app. */
export const FLOOR_PLAN_APP_TESTFLIGHT_URL = 'https://testflight.apple.com/join/7VeUtRFK'

/** Scanning guidelines (Box). */
export const FLOOR_PLAN_SCANNING_GUIDELINES_URL = 'https://airbnb.app.box.com/s/bfntfidlm3cnh1gklww6obxxlaqwedp2'

/**
 * Per-account, per-browser flag so the home banner stays dismissed after
 * pressing the X. Prefixed with the photographer id so logging out and back in
 * with a different account starts fresh instead of inheriting the dismissal.
 */
const FLOOR_PLAN_BANNER_DISMISSED_KEY_PREFIX = 'floor_plan_banner_dismissed:'

export const floorPlanBannerDismissedKey = (userId: number) => `${FLOOR_PLAN_BANNER_DISMISSED_KEY_PREFIX}${userId}`

export const FLOOR_PLAN_LINK_CLASSNAME = 'cursor-pointer font-medium text-purple-700 underline'
// The eligible iPhone models are served by the mocked devices endpoint
// (see `floorPlan.mock.ts`). This "other / not listed" value is the only
// device option owned by the form, since its label is translated.
export const DEVICE_NOT_LISTED_VALUE = 'not_listed'
